<template>
	<li class="list-group-item">
		<label :class="{ 'orange-border': is_pending, 'not-allowed-pointer': is_unavailable }">
			<input type="checkbox" :disabled="is_unavailable || disabled" :checked="is_checked"
				@change="changeValues($event.target.checked)" />
			{{ role_desc }}
		</label>
		<span v-if="credit_and_collection" class="label label-warning m-l-5">
			(C&amp;C Hold)
		</span>
	</li>
</template>

<script>
module.exports = {
	props: [
		'type',
		'role_cd',
		'role_desc',
		'user_account_roles',
		'is_unavailable',
		'credit_and_collection',
		'disabled'
	],
	computed: {
		is_pending() {
			switch (this.type) {
				case 'approval':
					return this.user_account_roles[this.role_cd] === 1;
				case 'request':
					return this.user_account_roles[this.role_cd] !== 0 && this.is_checked;
			}
		},
		is_checked() {
			switch (this.type) {
				case 'approval':
					return (Object.keys(this.user_account_roles).length > 0) && (this.user_account_roles[this.role_cd] === 0);
				case 'request':
					return (Object.keys(this.user_account_roles).length > 0) && (this.user_account_roles.hasOwnProperty(this.role_cd));
			}
		}
	},
	methods: {
		changeValues(checked) {
			if (this.is_unavailable || this.disabled) {
				return;
			}
			if (!checked) {
				this.$emit('delete', this.role_cd);
			} else {
				this.$emit('add', this.role_cd);
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// account-role-item.vue?acff1ee6